export const percentageToHexOpacity = (percentage) => {
    const decimalOpacity = percentage / 100;
    const hexadecimalOpacity = Math.round(decimalOpacity * 255);
    const hexString = hexadecimalOpacity.toString(16).padStart(2, '0').toUpperCase();
    return hexString;
};
//# sourceMappingURL=percentage-to-hex-opacity.js.map